'use strict';

import Pusher from 'pusher-js';


export default function() {
	var APP_KEY = null;
	var APP_CLUSTER = null;

	this.setAppKey = function(value) {
		APP_KEY = value;
	}

	this.setAppCluster = function(value) {
		APP_CLUSTER = value;
	}

	this.$get = function($$cookieReader, $rootScope, $log, $http, $q) {
		'ngInject';

		if (!APP_KEY) {
			$log.error('You must configure pusherProvider with your app key using the setAppKey method');
			return {};
		}

		try {
			// Add csrf token to authentication headers.  This requires having properly
			// configured the $httpProvider.  If using Django, this can be achieved by
			// injecting the 'brg.config.django' module into the app.
			var headers = {};
			headers[$http.defaults.xsrfHeaderName] = $$cookieReader()[$http.defaults.xsrfCookieName];
			var client = new Pusher(APP_KEY, {
				cluster: APP_CLUSTER,
				auth: {headers: headers},
				ecnrypted: true,
			});
			$log.debug('Connected to Pusher');
		} catch(e) {
			$log.warn('Could not connect to Pusher', e);
			return {};
		}

		var pusher = {};

		// Wraps client.subscribe to add a $bind method to the channel which calls
		// $rootScope.$digest after calling the callback function.
		pusher.subscribe = function(channelName) {
			var channel = client.subscribe(channelName);

			channel.ready = $q.defer();
			channel.bind('pusher:subscription_succeeded', function(status) {
				$log.debug(`Connected to ${channelName}`);
				channel.ready.resolve(status);
			});
			channel.bind('pusher:subscription_error', function(status) {
				$log.error(`Error subscribing to ${channelName}`);
				channel.ready.reject(status);
			});

			channel.$bind = function(eventName, callback) {
				channel.bind(eventName, function(data) {
					callback(data);
					$rootScope.$digest();
				});
			};

			return channel;
		};

		pusher.unsubscribe = function(channelName) {
			var channel = client.channel(channelName);
			channel.unsubscribe();
			$log.debug(`Unsubscribing from ${channelName}`); 
		};

		return pusher;
	};
}
